type Args = {
  redirectUrl?: string;
  isTestingLoggedIn?: boolean;
  tokens?: {
    idToken: string;
    accessToken: string;
    refreshToken?: string;
  };
};

export const REDIRECT_INFO_LOG_MESSAGE = "Redirecting logged in user";
export const UNEXPECTED_REDIRECT_ERROR_LOG_MESSAGE =
  "Unexpected error while redirecting";

/**
 * Redirect user after successful authentication.
 *
 * Cognito hosted-UI success: attach tokens as a URL fragment and navigate
 * to `redirectUrl || "/home"`.
 *
 * Django-session success: navigate to `redirectUrl || "/home"`. Destination
 * routing (customer/introducer/staff/partner_developer dispatch) lives in
 * iwoca-home-frontend's useMe + destination router — a full-page navigation
 * escapes the WebKit cookie-visibility gap (bug 255524) that was dropping
 * ~8k customers/day onto Webflow marketing.
 *
 * `isTestingLoggedIn` (session-check-on-mount) is no longer supported
 * without a `redirectUrl` — callers should use `hasCognitoSession()` for
 * that signal.
 */
export const redirectUser = ({
  redirectUrl,
  isTestingLoggedIn = false,
  tokens,
}: Args = {}): Promise<void> => {
  if (tokens) {
    const targetUrl = redirectUrl || "/home";
    const tokenFragment = `#idToken=${encodeURIComponent(tokens.idToken)}&accessToken=${encodeURIComponent(tokens.accessToken)}${tokens.refreshToken ? `&refreshToken=${encodeURIComponent(tokens.refreshToken)}` : ""}`;
    window.location.href = targetUrl + tokenFragment;
    return Promise.resolve();
  }

  if (isTestingLoggedIn && !redirectUrl) {
    return Promise.reject(
      new Error("redirectUser: session-check no longer supported"),
    );
  }

  window.location.href = redirectUrl || "/home";
  return Promise.resolve();
};
